<!-- Apmaksas veids -->
<div class="section">
  <div class="response-section-header">
    <div class="title-with-tooltip">
      <h5>{{ 'pages.viewInfoRequest.invoice.paymentType.title' | translate }}</h5>
      <app-tooltip text="invoicePaymentType" />
    </div>
    <div class="response-section-actions">
      @if (canEditInvoicing) {
        @if (!isPaymentEditMode) {
          <button class="secondary" [disabled]="isActionLoading" (click)="togglePaymentEdit()">
            {{ 'pages.viewInfoRequest.invoice.paymentType.edit' | translate }}
          </button>
        } @else {
          <button class="primary" [disabled]="isActionLoading" (click)="savePaymentType()">
            {{ 'pages.viewInfoRequest.invoice.paymentType.save' | translate }}
          </button>
          <button class="secondary cancel" [disabled]="isActionLoading" (click)="cancelPaymentEdit()">
            {{ 'pages.viewInfoRequest.invoice.paymentType.cancel' | translate }}
          </button>
        }
      }
    </div>
  </div>

  @if (isPaymentEditMode) {
    <form [formGroup]="paymentForm" class="payment-type-form mt-16">
      <div class="checkbox-row">
        <div class="checkbox-wrapper">
          <input id="paymentType_prepayment" type="checkbox" formControlName="prepaymentApplies" />
          <label for="paymentType_prepayment">{{ 'pages.viewInfoRequest.invoice.paymentType.prepayment' | translate }}</label>
        </div>
        <div class="checkbox-wrapper">
          <input id="paymentType_postpayment" type="checkbox" formControlName="postpaymentApplies" />
          <label for="paymentType_postpayment">{{ 'pages.viewInfoRequest.invoice.paymentType.postpayment' | translate }}</label>
        </div>
        <div class="checkbox-wrapper">
          <input id="paymentType_noCharge" type="checkbox" formControlName="noChargeApplies" />
          <label for="paymentType_noCharge">{{ 'pages.viewInfoRequest.invoice.paymentType.noCharge' | translate }}</label>
        </div>
      </div>
      <div class="field-wrapper">
        <div class="label-wrapper">
          <label class="form-label" for="paymentType_note">
            {{ 'pages.viewInfoRequest.invoice.paymentType.note' | translate }}
          </label>
          <app-tooltip [marginBottom]="false" text="invoicePaymentTypeNote" />
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            id="paymentType_note"
            formControlName="paymentNote"
            rows="4"
            [maxlength]="255"></textarea>
          <p class="length" [ngClass]="{ invalid: (paymentForm.get('paymentNote')?.value?.length || 0) > 255 }">
            {{ paymentForm.get('paymentNote')?.value?.length || 0 }}/255
          </p>
        </div>
      </div>
    </form>
  } @else if (selectedPaymentTypes.length > 0 || informationRequest.paymentNote) {
    <div class="payment-type-view mt-16">
      @for (key of selectedPaymentTypes; track key) {
        <span class="payment-type-item">
          <i class="bi bi-check-lg"></i>
          {{ key | translate }}
        </span>
      }
    </div>
    @if (informationRequest.paymentNote) {
      <div class="field-wrapper mt-16">
        <p class="form-label">{{ 'pages.viewInfoRequest.invoice.paymentType.note' | translate }}</p>
        <p class="form-value">{{ informationRequest.paymentNote }}</p>
      </div>
    }
  } @else {
    <p class="payment-type-empty">{{ 'pages.viewInfoRequest.invoice.paymentType.notSelected' | translate }}</p>
  }
</div>

<!-- Kalkulācija -->
<div class="section">
  <div class="response-section-header">
    <div class="title-with-tooltip">
      <h5>{{ 'pages.viewInfoRequest.invoice.calculation.title' | translate }}</h5>
      <app-tooltip text="invoiceCalculation" />
    </div>
    <div class="response-section-actions">
      @if (canEditInvoicing) {
        <button class="secondary" [disabled]="isAddingCalculation || isActionLoading" (click)="startAddCalculation()">
          <i class="bi bi-plus-circle"></i>
          {{ 'pages.viewInfoRequest.invoice.calculation.add' | translate }}
        </button>
      }
    </div>
  </div>

  <div class="drafts-content mt-16">
    @if (sortedCalculations.length > 0 || isAddingCalculation) {
      <div class="entry-list">
        <div class="entry-list-header row g-0 d-none d-md-flex">
          <div class="col-md-5">{{ 'pages.viewInfoRequest.invoice.calculation.fileDescription' | translate }}</div>
          <div class="col-md-2">{{ 'pages.viewInfoRequest.invoice.calculation.registeredBy' | translate }}</div>
          <div class="col-md-3">{{ 'pages.viewInfoRequest.invoice.calculation.files' | translate }}</div>
          <div class="col-md-2"></div>
        </div>

        @if (isAddingCalculation) {
          <div class="entry-list-row editing-row">
            <div class="row g-3">
              <div class="col-12 col-md-5 description-col">
                <div class="textarea-wrapper">
                  <textarea class="form-control lna" [(ngModel)]="newCalculationDescription" rows="4" maxlength="255"></textarea>
                  <p class="length" [ngClass]="{ invalid: newCalculationDescription.length > 255 }">
                    {{ newCalculationDescription.length }}/255
                  </p>
                </div>
              </div>
              <div class="col-6 col-md-2">-</div>
              <div class="col-6 col-md-3">
                <app-file-upload
                  [isEditMode]="true"
                  [existingFiles]="[]"
                  [type]="fileTypeCalculation"
                  [associatedEntityId]="newCalculationId"
                  [isSubmitting]="isSubmittingNewCalculationFiles"
                  [showDescription]="false"
                  [showBackofficeNote]="false"
                  (uploading)="handleNewCalculationFileUploads($event)" />
              </div>
              <div class="col-12 col-md-2">
                <div class="action-btn-wrapper">
                  <button class="primary" [disabled]="isActionLoading || isSubmittingNewCalculationFiles" (click)="confirmAddCalculation()">
                    {{ 'pages.viewInfoRequest.invoice.save' | translate }}
                  </button>
                  <button class="secondary" (click)="cancelAddCalculation()">
                    {{ 'pages.viewInfoRequest.invoice.cancel' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
        @for (calc of sortedCalculations; track calc.id) {
          @if (editingCalculationId === calc.id) {
            <div class="entry-list-row editing-row">
              <div class="row g-3">
                <div class="col-12 col-md-5 description-col">
                  <div class="textarea-wrapper">
                    <textarea class="form-control lna" [(ngModel)]="editingCalculationDescription" rows="4" maxlength="255"></textarea>
                    <p class="length" [ngClass]="{ invalid: editingCalculationDescription.length > 255 }">
                      {{ editingCalculationDescription.length }}/255
                    </p>
                  </div>
                </div>
                <div class="col-6 col-md-2">
                  {{ calc.user.firstName }} {{ calc.user.lastName }}<br/>
                  @if (calc.user.structuralUnitCodes.length) {
                    {{ calc.user.structuralUnitCodes.join(', ') }}<br/>
                  }
                  {{ formatDatetime(calc.modifiedOn || calc.createdOn) }}
                </div>
                <div class="col-6 col-md-3">
                  <app-file-upload
                    [existingFiles]="calc.informationRequestCalculationFiles || []"
                    [isEditMode]="true"
                    [isSubmitting]="isSubmittingCalculationFiles"
                    [type]="fileTypeCalculation"
                    [associatedEntityId]="calc.id"
                    [showDescription]="false"
                    [showBackofficeNote]="false"
                    [allowToAddNewFile]="true"
                    [noPadding]="true"
                    (uploading)="handleEditCalculationFileUploads($event)" />
                </div>
                <div class="col-12 col-md-2">
                  <div class="action-btn-wrapper">
                    <button class="primary" [disabled]="isActionLoading || isSubmittingCalculationFiles" (click)="confirmEditCalculation()">
                      {{ 'pages.viewInfoRequest.invoice.save' | translate }}
                    </button>
                    <button class="secondary" (click)="cancelEditCalculation()">
                      {{ 'pages.viewInfoRequest.invoice.cancel' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="entry-list-row">
              <div class="row g-3">
                <div class="col-12 col-md-5 description-col">{{ calc.description || '-' }}</div>
                <div class="col-6 col-md-2">
                  {{ calc.user.firstName }} {{ calc.user.lastName }}<br/>
                  @if (calc.user.structuralUnitCodes.length) {
                    {{ calc.user.structuralUnitCodes.join(', ') }}<br/>
                  }
                  {{ formatDatetime(calc.modifiedOn || calc.createdOn) }}
                </div>
                <div class="col-6 col-md-3">
                  <app-file-upload
                    [existingFiles]="calc.informationRequestCalculationFiles || []"
                    [isEditMode]="false"
                    [isSubmitting]="false"
                    [type]="fileTypeCalculation"
                    [associatedEntityId]="calc.id"
                    [showDescription]="false"
                    [showBackofficeNote]="false"
                    [noPadding]="true" />
                </div>
                <div class="col-12 col-md-2">
                  @if (canEditInvoicing) {
                    <div class="action-btn-wrapper">
                      <button class="link" [disabled]="isActionLoading" (click)="startEditCalculation(calc)">
                        <img src="assets/images/edit-icon.svg" alt="edit" />
                        {{ 'pages.viewInfoRequest.invoice.edit' | translate }}
                      </button>
                      <button class="link" [disabled]="isActionLoading" (click)="deleteCalculation(calc.id)">
                        <img src="assets/images/delete-icon.svg" alt="delete" />
                        {{ 'pages.viewInfoRequest.invoice.delete' | translate }}
                      </button>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }
      </div>
    } @else {
      <p class="empty">{{ 'pages.viewInfoRequest.invoice.calculation.empty' | translate }}</p>
    }
  </div>
</div>

<!-- Rēķins -->
<div class="invoice-summary">
  <div class="response-section-header">
    <div class="title-with-tooltip">
      <h5>{{ 'pages.viewInfoRequest.invoice.title' | translate }}</h5>
      <app-tooltip text="invoiceSection" />
    </div>
    <div class="response-section-actions">
      <span class="tooltip-host" [title]="markPaidTooltip ? (markPaidTooltip | translate) : ''">
        <button class="primary" [disabled]="!canMarkPaid || isActionLoading" (click)="openMarkPaidModal()">
          {{ 'pages.viewInfoRequest.invoice.markPaid' | translate }}
        </button>
      </span>
      @if (canEditInvoicing) {
        <button class="secondary" [disabled]="isAddingInvoice || isActionLoading" (click)="startAddInvoice()">
          <i class="bi bi-plus-circle"></i>
          {{ 'pages.viewInfoRequest.invoice.addInvoice' | translate }}
        </button>
      }
    </div>
  </div>

  <div class="row g-3 mt-16">
    <div class="col-12 col-md-6 info-field">
      <p class="field-label-bold">{{ 'pages.viewInfoRequest.invoice.clientDeliveryMethod' | translate }}</p>
      <p class="field-value">{{ getInvoiceDeliveryMethodLabel(informationRequest.invoiceDeliveryMethod) | translate }}</p>
    </div>
    @if (getInvoiceDeliveryDetail()) {
      <div class="col-12 col-md-6 info-field">
        <p class="field-label-bold">
          @if (informationRequest.invoiceDeliveryMethod === 'Email') {
            {{ 'pages.viewInfoRequest.invoice.deliveryEmail' | translate }}
          } @else if (informationRequest.invoiceDeliveryMethod === 'PostalMail') {
            {{ 'pages.viewInfoRequest.invoice.deliveryAddress' | translate }}
          } @else if (informationRequest.invoiceDeliveryMethod === 'Archive') {
            {{ 'pages.viewInfoRequest.invoice.deliveryArchive' | translate }}
          } @else {
            {{ 'pages.viewInfoRequest.invoice.deliveryDetail' | translate }}
          }
        </p>
        <p class="field-value">{{ getInvoiceDeliveryDetail() }}</p>
      </div>
    }
  </div>
</div>

<!-- New invoice block (shown at top while being added) -->
@if (isAddingInvoice) {
  <div class="section">
    <div class="response-section-header">
      <div class="title-with-tooltip">
        <h5>{{ 'pages.viewInfoRequest.invoice.invoiceNumber' | translate }} {{ invoices.length + 1 }}</h5>
      </div>
    </div>
    <div class="other-response-content mt-16">
      <div class="entry-list">
        <div class="entry-list-header row g-0 d-none d-md-flex">
          <div class="col-md-5">{{ 'pages.viewInfoRequest.invoice.calculation.fileDescription' | translate }}</div>
          <div class="col-md-2">{{ 'pages.viewInfoRequest.invoice.calculation.registeredBy' | translate }}</div>
          <div class="col-md-3">{{ 'pages.viewInfoRequest.invoice.calculation.files' | translate }}</div>
          <div class="col-md-2"></div>
        </div>

        <div class="entry-list-row editing-row">
          <div class="row g-3">
            <div class="col-12 col-md-5 description-col">
              <div class="textarea-wrapper">
                <textarea class="form-control lna" [(ngModel)]="newInvoiceDescription" rows="4" maxlength="255"></textarea>
                <p class="length" [ngClass]="{ invalid: newInvoiceDescription.length > 255 }">
                  {{ newInvoiceDescription.length }}/255
                </p>
              </div>
            </div>
            <div class="col-6 col-md-2">-</div>
            <div class="col-6 col-md-3">
              <app-file-upload
                [isEditMode]="true"
                [existingFiles]="[]"
                [type]="fileTypeInvoice"
                [associatedEntityId]="newInvoiceId"
                [isSubmitting]="isSubmittingNewInvoiceFiles"
                [showDescription]="false"
                [showBackofficeNote]="false"
                [maxFiles]="1"
                (filesChanged)="onNewInvoiceFilesChanged($event)"
                (uploading)="handleNewInvoiceFileUploads($event)" />
            </div>
            <div class="col-12 col-md-2">
              <div class="action-btn-wrapper">
                <button class="primary" [disabled]="isActionLoading || isSubmittingNewInvoiceFiles" (click)="confirmAddInvoice()">
                  {{ 'pages.viewInfoRequest.invoice.save' | translate }}
                </button>
                <button class="secondary" (click)="cancelAddInvoice()">
                  {{ 'pages.viewInfoRequest.invoice.cancel' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- Each invoice block -->
@for (invoice of sortedInvoices; track invoice.id) {
  <div class="section">
    <div class="response-section-header">
      <div class="title-with-tooltip">
        <h5>{{ 'pages.viewInfoRequest.invoice.invoiceNumber' | translate }} {{ invoice.ordinalNumber }}</h5>
      </div>
      @if ((invoice.sendingEvents.length > 0 || canEditInvoicing) && canSendInvoice) {
        <div class="response-section-actions">
          <button class="primary" [disabled]="isActionLoading" (click)="openSendEmailModal(invoice)">
            {{ 'pages.viewInfoRequest.invoice.sendEmail' | translate }}
          </button>
          <button class="primary" [disabled]="isActionLoading" (click)="openSendPortalModal(invoice)">
            {{ 'pages.viewInfoRequest.invoice.sendPortal' | translate }}
          </button>
          <button class="secondary" [disabled]="isActionLoading" (click)="openMarkSentModal(invoice)">
            {{ 'pages.viewInfoRequest.invoice.markSent' | translate }}
          </button>
        </div>
      }
    </div>

    <div class="other-response-content mt-16">
      <div class="entry-list">
        <div class="entry-list-header row g-0 d-none d-md-flex">
          <div class="col-md-5">{{ 'pages.viewInfoRequest.invoice.calculation.fileDescription' | translate }}</div>
          <div class="col-md-2">{{ 'pages.viewInfoRequest.invoice.calculation.registeredBy' | translate }}</div>
          <div class="col-md-3">{{ 'pages.viewInfoRequest.invoice.calculation.files' | translate }}</div>
          <div class="col-md-2"></div>
        </div>

        @if (editingInvoiceId === invoice.id) {
          <div class="entry-list-row editing-row">
            <div class="row g-3">
              <div class="col-12 col-md-5 description-col">
                <div class="textarea-wrapper">
                  <textarea class="form-control lna" [(ngModel)]="editingInvoiceDescription" rows="4" maxlength="255"></textarea>
                  <p class="length" [ngClass]="{ invalid: editingInvoiceDescription.length > 255 }">
                    {{ editingInvoiceDescription.length }}/255
                  </p>
                </div>
              </div>
              <div class="col-6 col-md-2">
                {{ invoice.user.firstName }} {{ invoice.user.lastName }}<br/>
                @if (invoice.user.structuralUnitCodes.length) {
                  {{ invoice.user.structuralUnitCodes.join(', ') }}<br/>
                }
                {{ formatDatetime(invoice.modifiedOn || invoice.createdOn) }}
              </div>
              <div class="col-6 col-md-3">
                <app-file-upload
                  #editInvoiceFileUpload
                  [existingFiles]="invoice.informationRequestInvoiceFiles || []"
                  [isEditMode]="true"
                  [isSubmitting]="isSubmittingInvoiceFiles"
                  [type]="fileTypeInvoice"
                  [associatedEntityId]="invoice.id"
                  [showDescription]="false"
                  [showBackofficeNote]="false"
                  [allowToAddNewFile]="true"
                  [noPadding]="true"
                  [maxFiles]="1"
                  [disableDelete]="invoice.sendingEvents.length > 0"
                  (uploading)="handleEditInvoiceFileUploads($event)" />
              </div>
              <div class="col-12 col-md-2">
                <div class="action-btn-wrapper">
                  <button class="primary" [disabled]="isActionLoading || isSubmittingInvoiceFiles" (click)="confirmEditInvoice()">
                    {{ 'pages.viewInfoRequest.invoice.save' | translate }}
                  </button>
                  <button class="secondary" (click)="cancelEditInvoice()">
                    {{ 'pages.viewInfoRequest.invoice.cancel' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <div class="entry-list-row">
            <div class="row g-3">
              <div class="col-12 col-md-5 description-col">{{ invoice.description || '-' }}</div>
              <div class="col-6 col-md-2">
                {{ invoice.user.firstName }} {{ invoice.user.lastName }}<br/>
                @if (invoice.user.structuralUnitCodes.length) {
                  {{ invoice.user.structuralUnitCodes.join(', ') }}<br/>
                }
                {{ formatDatetime(invoice.modifiedOn || invoice.createdOn) }}
              </div>
              <div class="col-6 col-md-3">
                <app-file-upload
                  [existingFiles]="invoice.informationRequestInvoiceFiles || []"
                  [isEditMode]="false"
                  [isSubmitting]="false"
                  [type]="fileTypeInvoice"
                  [associatedEntityId]="invoice.id"
                  [showDescription]="false"
                  [showBackofficeNote]="false"
                  [noPadding]="true" />
              </div>
              <div class="col-12 col-md-2">
                @if (canEditInvoicing) {
                  <div class="action-btn-wrapper">
                    <button class="link" [disabled]="isActionLoading" (click)="startEditInvoice(invoice)">
                      <img src="assets/images/edit-icon.svg" alt="edit" />
                      {{ 'pages.viewInfoRequest.invoice.edit' | translate }}
                    </button>
                    <button class="link" [disabled]="isActionLoading || !canDeleteInvoice(invoice)" (click)="deleteInvoice(invoice)">
                      <img src="assets/images/delete-icon.svg" alt="delete" />
                      {{ 'pages.viewInfoRequest.invoice.delete' | translate }}
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      @for (evt of invoice.sendingEvents; track evt.id) {
        <div class="sending-event-detail">
          <p class="sending-event-header">
            {{ 'pages.viewInfoRequest.invoice.sendingEventNumber' | translate }} {{ evt.ordinalNumber }}
            &nbsp;•&nbsp; <strong>{{ evt.registeredByUserName || '-' }}</strong>
            &nbsp;•&nbsp; {{ formatDatetime(evt.occurredOn, false) }}
          </p>
          <div class="row g-3">
            <div class="col-12 col-md-6 info-field">
              <p class="field-label-bold">{{ 'pages.viewInfoRequest.invoice.actualDeliveryMethod' | translate }}</p>
              <p class="field-value">{{ getActualDeliveryMethodLabel(evt.actualDeliveryMethod) | translate }}</p>
            </div>
            @if (evt.addressDetail) {
              <div class="col-12 col-md-6 info-field">
                <p class="field-label-bold">
                  @if (evt.actualDeliveryMethod === 'Email') {
                    {{ 'pages.viewInfoRequest.invoice.deliveryEmail' | translate }}
                  } @else {
                    {{ 'pages.viewInfoRequest.invoice.addressDetail' | translate }}
                  }
                </p>
                <p class="field-value">{{ evt.addressDetail }}</p>
              </div>
            }
          </div>
          @if (evt.emailSubject) {
            <div class="info-field mt-16">
              <p class="field-label-bold">{{ 'pages.viewInfoRequest.invoice.emailSubject' | translate }}</p>
              <p class="field-value">{{ evt.emailSubject }}</p>
            </div>
          }
          @if (evt.emailBody) {
            <div class="info-field mt-16">
              <p class="field-label-bold">{{ 'pages.viewInfoRequest.invoice.emailBody' | translate }}</p>
              <p class="field-value">{{ evt.emailBody }}</p>
            </div>
          }
          @if (evt.clientMessage) {
            <div class="info-field mt-16">
              <p class="field-label-bold">{{ 'pages.viewInfoRequest.invoice.clientMessage' | translate }}</p>
              <p class="field-value">{{ evt.clientMessage }}</p>
            </div>
          }
          @if (evt.backofficeNote) {
            <div class="info-field mt-16">
              <p class="field-label-bold">{{ 'pages.viewInfoRequest.invoice.lnaNotes' | translate }}</p>
              <p class="field-value">{{ evt.backofficeNote }}</p>
            </div>
          }
          @if (evt.attachmentName) {
            <div class="info-field mt-16">
              <p class="field-label-bold">{{ 'pages.viewInfoRequest.invoice.attachmentFile' | translate }}</p>
              <p class="field-value sending-event-attachment">
                <img class="file-icon" [attr.alt]="'imgAlt.fileIcon' | translate" src="assets/images/file-icon.svg" />
                <span>{{ evt.attachmentName }}</span>
              </p>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<app-ir-invoice-send-email-modal
  [isOpen]="isSendEmailModalOpen"
  [informationRequest]="informationRequest"
  [invoice]="activeInvoice"
  [isLoading]="isActionLoading"
  (confirmed)="onSendEmailConfirmed($event)"
  (closed)="isSendEmailModalOpen = false" />

<app-ir-invoice-send-portal-modal
  [isOpen]="isSendPortalModalOpen"
  [invoice]="activeInvoice"
  [isLoading]="isActionLoading"
  (confirmed)="onSendPortalConfirmed()"
  (closed)="isSendPortalModalOpen = false" />

<app-ir-invoice-mark-sent-modal
  [isOpen]="isMarkSentModalOpen"
  [informationRequest]="informationRequest"
  [structuralUnits]="structuralUnits"
  [isLoading]="isActionLoading"
  (confirmed)="onMarkSentConfirmed($event)"
  (closed)="isMarkSentModalOpen = false" />

<app-ir-invoice-mark-paid-modal
  [isOpen]="isMarkPaidModalOpen"
  [informationRequest]="informationRequest"
  [isLoading]="isActionLoading"
  (confirmed)="onMarkPaidConfirmed($event)"
  (closed)="isMarkPaidModalOpen = false" />
